export default {
  organization: state => state.Organization,
  teacher: state => state.Teacher,
  font: state => state.Font,
  credits: state => state.Credits,
  user: state => state.User,
  commoditie: state => state.Commoditie,
  course: state => state.Course,
  vip: state => state.Vip,
  creation: state => state.Creation,
  showServicePopup: state => state.Organization.showServicePopup
}
